import { VipFragment } from '@graphql/generated';
import { useTranslation } from '@shared/core';
import { Flex, FormControl, InputV2 } from '@withjoy/joykit';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useVIPFormState } from '../hooks/useVIPFormState';
import { EventPhotoPicker } from '@shared/components/EventPhotoPicker/EventPhotoPicker';
import { VIPDescription } from './VIPDescription';
import { VIPImage } from './VIPImage';

export type VIPData = Omit<VipFragment, 'photo' | 'id'>;

type VIPFormProps = {
  initialData: VIPData;
  onSubmit: (data: VIPData) => void;
};

export const VIPForm = forwardRef((props: VIPFormProps, ref) => {
  const { tq } = useTranslation('VIPForm');
  const { initialData, onSubmit } = props;
  const { state, setValue, meta } = useVIPFormState(initialData);
  const [photoPickerOpen, setPhotoPickerOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    submit: () => {
      onSubmit(state);
    },
  }));

  return (
    <>
      <Flex
        flexDirection="column"
        gap="4"
      >
        <FormControl label={tq`Photo`}>
          <Flex alignItems="flex-start">
            <VIPImage
              data={state}
              onClick={() => setPhotoPickerOpen(true)}
            />
          </Flex>
        </FormControl>
        <FormControl
          label={tq`Name`}
          isInvalid={meta.alias?.error}
        >
          <InputV2
            placeholder={tq`Name`}
            value={state.alias ?? ''}
            onChange={e => setValue('alias', e.target.value)}
          />
        </FormControl>
        <FormControl
          label={tq`Title`}
          isInvalid={meta.title?.error}
        >
          <InputV2
            placeholder={tq`Title`}
            value={state.title ?? ''}
            onChange={e => setValue('title', e.target.value)}
          />
        </FormControl>
        <FormControl
          label={tq`Description`}
          isInvalid={meta.description?.error}
        >
          <VIPDescription
            placeholder={tq`Description`}
            value={state.description ?? ''}
            onChange={e => setValue('description', e.target.value)}
          />
        </FormControl>
      </Flex>
      <EventPhotoPicker
        onPhotoSelect={photo => setValue('photoUrl', photo.url)}
        isOpen={photoPickerOpen}
        onClose={() => setPhotoPickerOpen(false)}
      />
    </>
  );
});
